import { useEffect, useState } from "react";
import { loadTenantByHost, applyTenantBranding, isKairosaHost } from "@/lib/tenantHost";
import { applyTenantCurrency } from "@/lib/currency";
import { applyBackgroundTheme } from "@/lib/backgroundThemes";

/**
 * At app boot, if we're being served under a customer's custom domain,
 * fetch that tenant's public branding and inject it into :root so the WHOLE
 * shell (marketing site + login + dashboard) instantly feels branded.
 *
 * Also applies currency + background theme + custom wallpaper so the login
 * screen already looks like the tenant's workspace — before the user signs in.
 *
 * Renders a small "Powered by Kairosa" badge for custom-domain visitors.
 */
export function TenantHostBoot() {
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    (async () => {
      const t = await loadTenantByHost();
      if (t) {
        applyTenantBranding(t);
        applyTenantCurrency(t.currency);
        const url = t.wallpaper_url
          ? `${process.env.REACT_APP_BACKEND_URL}${t.wallpaper_url}`
          : null;
        applyBackgroundTheme(t.background_theme, url, t.wallpaper_overlay_pct);
        setTenant(t);
      }
    })();
  }, []);

  if (!tenant || isKairosaHost()) return null;

  return (
    <a
      href="https://kairos.app"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="powered-by-kairos"
      className="fixed bottom-4 right-4 z-40 text-[10px] uppercase tracking-[0.22em] text-muted-foreground bg-background/80 backdrop-blur border border-border rounded-full px-3 py-1.5 hover:text-foreground transition-colors"
    >
      Powered by Kairosa
    </a>
  );
}
